import useRisksmartUser from '@risksmart-app/components/src/hooks/useRisksmartUser';
import { getEnv } from '@risksmart-app/components/src/utils/environment';

const isProduction = process.env.NODE_ENV === 'production';
const mockIsCustomerSupport =
  !isProduction &&
  getEnv('REACT_APP_MOCK_IS_CUSTOMER_SUPPORT', true) === 'true';

/**
 * Returns whether the current user is a CustomerSupport user.
 * In local dev, falls back to REACT_APP_MOCK_IS_CUSTOMER_SUPPORT
 * since the Auth0 JWT claim is unavailable when using real Auth0
 * with the dev tenant.
 */
export const useIsCustomerSupport = (): boolean => {
  const { user } = useRisksmartUser();

  return (
    user?.isCustomerSupport ||
    user?.allowedRoles?.includes('CustomerSupport') ||
    mockIsCustomerSupport
  );
};
